module.exports = __webpack_public_path__ + "4c2e6bfaf6d0507bdde153f9f89e1754.svg";